import { Component, h } from '@stencil/core';
import { ReviewStatus } from '@ugc-components/ugc-pdp-review/interface';
import state from '@ugc-store';
import { ReviewNoDataIcon } from '../../icons';

@Component({
  tag: 'ugc-review-no-data',
  shadow: false,
})
export class UgcReviewNoData {
  render() {
    const {
      reviewStaticLanguage: {
        IDS_REVIEWS_BE_THE_FIRST = '',
        IDS_REVIEWS_NO_REVIEWED_YET = '',
        IDS_UGC_REVIEW_WRITE_A_REVIEW = '',
        IDS_MY_REVIEW_UPDATE_MY_REVIEW = '',
      } = {},
      actionPermission: { review: reviewButtonDisabled },
      ids = [],
      userReviewData,
      isUpdateReview,
      productInfo: { productId },
      isDesktop,
    } = state;
    const isHasPendingReview = userReviewData.status === ReviewStatus.ForReview || userReviewData.isFrozen;

    const buttonWrapStyle = { display: 'block', width: '343px', margin: '16px auto' };
    return (
      !isHasPendingReview &&
      ids.length === 0 &&
      state.isReviewListLoaded && (
        <div class={`flex-col-center-center text-center ${isDesktop ? 'mt-48 mb-16' : 'bg-white my-8 py-50'}`}>
          <ReviewNoDataIcon width="160" height="160" />
          <p class="mt-24 mb-4 fs-24 bold lh-32">{IDS_REVIEWS_BE_THE_FIRST}</p>
          <p class="fs-16">{IDS_REVIEWS_NO_REVIEWED_YET}</p>

          {isDesktop && (
            <ugc-button
              height="48"
              style={buttonWrapStyle}
              disabled={reviewButtonDisabled}
              onClick={() => {
                window.location.href = `/ugc/product/${productId}/review`;
              }}
            >
              {isUpdateReview ? IDS_MY_REVIEW_UPDATE_MY_REVIEW : IDS_UGC_REVIEW_WRITE_A_REVIEW}
            </ugc-button>
          )}
        </div>
      )
    );
  }
}
